export default function FooterColumn({ title, links, children }) {
  return (
    <div className="flex flex-col gap-8 max-sm:gap-4">
      <h3 className="text-xs tracking-tight text-black">{title}</h3>
      {links ? (
        <div className="flex flex-col gap-2.5 font-medium">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="text-base tracking-tight text-black hover:text-gray-700 font-medium"
            >
              {link.name}
            </a>
          ))}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
